/**
 * Shared table styles
 * Consistent styling for all tables across the application
 */

import type { CSSProperties } from 'react';
import { COLORS } from '../constants/theme';

export const TABLE_HEADER_STYLE: CSSProperties = {
  textAlign: 'left',
  padding: '12px 16px',
  fontSize: '13px',
  fontWeight: '600',
  color: '#6b7280',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

export const TABLE_CELL_STYLE: CSSProperties = {
  padding: '16px',
  fontSize: '14px',
};

export const TABLE_ROW_STYLE: CSSProperties = {
  borderBottom: `1px solid ${COLORS.border.light}`,
};

export const TABLE_ROW_HOVER_STYLE: CSSProperties = {
  backgroundColor: COLORS.background.secondary,
  cursor: 'pointer',
};

export const TABLE_CONTAINER_STYLE: CSSProperties = {
  backgroundColor: 'white',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
};
